import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { clearSuccessMessage } from 'slices/appSlice';
import { toogleSuccessMessage } from 'slices/appSlice';
import { appSelector } from 'slices/appSlice';

function SuccessMessageModal({ }) {

  const dispatch = useDispatch()
  const { successMessage } = useSelector(appSelector);
  console.log("successMessage", successMessage)
  const { show, message } = successMessage

  const toggle = () => {
    dispatch(clearSuccessMessage())
  }

  return (
    <div>
      <Modal isOpen={show} toggle={toggle} >
        <ModalHeader toggle={toggle}>Modal title</ModalHeader>
        <ModalBody>
          {message}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={toggle}>
            Do Something
          </Button>{' '}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default SuccessMessageModal;